const isDebugLogEnabled = () => {
  return localStorage.getItem('_debugEnabled') === '1';
}

export {isDebugLogEnabled};
